import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { AccesoService } from '../../acceso/acceso.service';
import { map,filter, pluck } from 'rxjs/operators';
import { SessionStorageService } from '../../storage/sessionStorage.service';
import { Observable } from "rxjs";
import { LocalService } from '../../storage/localService';
@Injectable({
  providedIn: 'root'
})
export class SimuladorService {

  readonly urlBase =  environment.rutaBase;
  message: Observable<any>;
  header : HttpHeaders;
  idEmpresa_Factor : any;
  constructor( private http : HttpClient,  private accesoService :AccesoService, private sessionStorageService: SessionStorageService,private localService : LocalService) {    
    
     this.header = this.accesoService.desencriptarTOKEN();   
     this.datoStorage()

  }
  datoStorage(){
    this.message = this.sessionStorageService.storageChange$.pipe(
      filter(({ storageArea }) => storageArea === "sessionStorage"),
      filter(({ key }) => key === '1cefada07eb9',),
      pluck("value")
    );
   this.message.subscribe(val => this.idEmpresa_Factor = val - this.localService.getJsonValue('numeroRandom'))
   if (this.idEmpresa_Factor == undefined) {
    this.idEmpresa_Factor = Number(sessionStorage.getItem('1cefada07eb9')) - this.localService.getJsonValue('numeroRandom')
   } 
  }
  obtenerRanking(RUC_ADQ){
    let headers = this.header;
    return this.http.get(`${this.urlBase}/Top10K?idEmpresa_Factor=${this.idEmpresa_Factor}&Num_Doc_Identificacion_ADQ=${RUC_ADQ}`,{headers})
          .pipe( map (res=> {return res;}));  
  }
  
  FiltroListadoSimulador(FInicial : any ,FFinal :any , rucProv : string = '', RucAqd : string ='' , canal  :string ='' ,user:string){
    
    let headers = this.header;
    return this.http.get(`${this.urlBase}/Simulador?NumeroPagina=1&NumeroRegistro=100000&idEmpresa_Factor=${this.idEmpresa_Factor}&FechaInicial=${FInicial}&FechaFinal=${FFinal}&Canal=${canal}&Num_Doc_Identificacion_Prov=${rucProv}&Num_Doc_Identificacion_ADQ=${RucAqd}&User=${user}`,{headers});  
  }

  obtenerTEM( body :any){
    let headers = this.header;
    return this.http.post(`${this.urlBase}/SimuladorTEM?idEmpresa_Factor=${this.idEmpresa_Factor}`,body,{headers});
  }

  guardarSimulador(body :any){
    let headers = this.header;
    return this.http.post(`${this.urlBase}/Simulador?idEmpresa_Factor=${this.idEmpresa_Factor}`,body,{headers});
  }

  guardarSimuladorDetalle(idSimulador : number ,body :any){
    let headers = this.header;
    return this.http.post(`${this.urlBase}/SimuladorDetalle/${idSimulador}?idEmpresa_Factor=${this.idEmpresa_Factor}`,body,{headers});  
  }

  factoring( body :any){
    let headers = this.header;
    return this.http.post(`${this.urlBase}/SimuladorCalc?idEmpresa_Factor=${this.idEmpresa_Factor}`,body,{headers});
  }

  factoringResume( body :any){
    let headers = this.header;
    return this.http.post(`${this.urlBase}/CalcularComision?idEmpresa_Factor=${this.idEmpresa_Factor}`,body,{headers});
  }


  obtenerSimulador(idSimulador :number){
    let headers = this.header;
    return this.http.get(`${this.urlBase}/SimuladorxID?idEmpresa_Factor=${this.idEmpresa_Factor}&idSimulador=${idSimulador}`,{headers})
            .pipe(map(res =>{  return res[0] })  );
  }


  obtenerSimuladorDetalle(idSimulador :number){
    let headers = this.header;
    return this.http.get(`${this.urlBase}/SimuladorDetalle?idEmpresa_Factor=${this.idEmpresa_Factor}&idSimulador=${idSimulador}`,{headers});
  }


}
